import type {
  AttendanceRecord,
  AttendanceSummary,
  DropdownOption,
  PendingRequest,
  TabKey,
} from '../types/hrmsAttendanceLeave.types'
import { AttendanceStatsRow } from './AttendanceStatsRow'
import { PendingRequestsCard } from './PendingRequestsCard'
import { TodayAttendanceCard } from './TodayAttendanceCard'

interface AttendanceOverviewProps {
  summary: AttendanceSummary
  // Today's attendance
  attendanceRecords: AttendanceRecord[]
  todayTotal?: number
  todayPage?: number
  todayLimit?: number
  todayLoading?: boolean
  todaySearch?: string
  onTodaySearchChange?: (val: string) => void
  todayDepartmentId?: string
  onTodayDepartmentChange?: (dept: string) => void
  departmentOptions?: DropdownOption[]
  todayStatus?: string
  onTodayStatusChange?: (status: string) => void
  onTodayPageChange?: (page: number) => void

  // Pending requests
  pendingRequests: PendingRequest[]
  pendingTotal?: number
  pendingPage?: number
  pendingLimit?: number
  pendingLoading?: boolean
  pendingSearch?: string
  onPendingSearchChange?: (val: string) => void
  pendingDepartmentId?: string
  onPendingDepartmentChange?: (dept: string) => void
  pendingRequestType?: string
  onPendingRequestTypeChange?: (type: string) => void
  onPendingPageChange?: (page: number) => void

  onSwitchTab: (tab: TabKey) => void
  onViewAttendance: (id: string) => void
  onReviewRequest: (id: string) => void
}

export function AttendanceOverview({
  summary,
  attendanceRecords,
  todayTotal,
  todayPage,
  todayLimit,
  todayLoading,
  todaySearch,
  onTodaySearchChange,
  todayDepartmentId,
  onTodayDepartmentChange,
  departmentOptions,
  todayStatus,
  onTodayStatusChange,
  onTodayPageChange,

  pendingRequests,
  pendingTotal,
  pendingPage,
  pendingLimit,
  pendingLoading,
  pendingSearch,
  onPendingSearchChange,
  pendingDepartmentId,
  onPendingDepartmentChange,
  pendingRequestType,
  onPendingRequestTypeChange,
  onPendingPageChange,

  onSwitchTab,
  onViewAttendance,
  onReviewRequest,
}: AttendanceOverviewProps) {
  return (
    <div className="space-y-6 min-w-0">
      <div className="min-w-0">
        <AttendanceStatsRow summary={summary} />
      </div>

      <div className="min-w-0">
        <TodayAttendanceCard
          records={attendanceRecords}
          total={todayTotal}
          page={todayPage}
          limit={todayLimit}
          loading={todayLoading}
          search={todaySearch}
          onSearchChange={onTodaySearchChange}
          departmentId={todayDepartmentId}
          onDepartmentChange={onTodayDepartmentChange}
          departmentOptions={departmentOptions}
          status={todayStatus}
          onStatusChange={onTodayStatusChange}
          onPageChange={onTodayPageChange}
          onViewAll={() => onSwitchTab('attendance')}
          onViewAttendance={onViewAttendance}
        />
      </div>

      <div className="min-w-0">
        <PendingRequestsCard
          requests={pendingRequests}
          total={pendingTotal}
          page={pendingPage}
          limit={pendingLimit}
          loading={pendingLoading}
          search={pendingSearch}
          onSearchChange={onPendingSearchChange}
          departmentId={pendingDepartmentId}
          onDepartmentChange={onPendingDepartmentChange}
          departmentOptions={departmentOptions}
          requestType={pendingRequestType}
          onRequestTypeChange={onPendingRequestTypeChange}
          onPageChange={onPendingPageChange}
          onViewAll={() => onSwitchTab('leave')}
          onReviewRequest={onReviewRequest}
        />
      </div>
    </div>
  )
}
